<bizz-icon class="mx-[15px] cursor-pointer hover:text-blue-400 hover:opacity-100"
           [ngClass]="{'rotate-45 opacity-50 text-sidebar-header' : (unPinned | async), 'rotate-0 opacity-100 text-blue-500' : !(unPinned | async) }"
           iconName="thumbtack" (click)="setPinSidebarState()">
</bizz-icon>
